import { jsx, jsxs } from "react/jsx-runtime";
import { HALF_AD_TYPE } from "../constants.js";
import { isHalfBannerWithFourCorners } from "../lib.js";
import { FourCorners } from "../../FourCorners/index.js";
import { CostcoBox } from "../../../Util/CostcoBox.js";
import { ResponsiveContainer } from "./styles.js";
const HalfBannerWithFourCorners = ({
  ads,
  allAdTypes,
  itemType
}) => {
  if (!isHalfBannerWithFourCorners(allAdTypes)) {
    return null;
  }
  const halfBannerIndex = allAdTypes.findIndex(
    (adType) => adType === HALF_AD_TYPE
  );
  if (halfBannerIndex === -1) {
    return null;
  }
  const HalfBannerAd = ads[halfBannerIndex];
  const fourCornersAds = ads.filter((_, index) => {
    return index !== halfBannerIndex;
  });
  return /* @__PURE__ */ jsx(CostcoBox, { sx: { containerType: "inline-size" }, children: /* @__PURE__ */ jsxs(ResponsiveContainer, { children: [
    halfBannerIndex === 0 && /* @__PURE__ */ jsx(CostcoBox, { sx: { flex: 1 }, children: HalfBannerAd }),
    /* @__PURE__ */ jsx(
      CostcoBox,
      {
        sx: {
          flex: 1
        },
        children: /* @__PURE__ */ jsx(FourCorners, { data: fourCornersAds, type: itemType })
      }
    ),
    halfBannerIndex === 4 && /* @__PURE__ */ jsx(CostcoBox, { sx: { flex: 1 }, children: HalfBannerAd })
  ] }) });
};
export {
  HalfBannerWithFourCorners
};
